import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { countries, ui } from '@/constants';
import { OrderErrorCode, OrderWithContext } from '@/models';

@Component({
  name: 'CmgMaxEntreeLimitModal',
})
export default class CmgMaxEntreeLimitModal extends Vue {

  get BYOString(): string {
    return 'FAMILY MEAL';
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.maxEntreeLimitModal.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }
  
  get currentOrder(): OrderWithContext | null {
    return this.$store.getters.currentOrder;
  }

  get errorMessage(): string {
    return this.$appStore.state.ui.modals.maxEntreeLimitModal.args?.errorMessage ?? '';
  }

  get errorCode(): string {
    return this.$appStore.state.ui.modals.maxEntreeLimitModal.args?.errorCode ?? '';
  }

  get shouldShowCateringLink(): boolean {
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus){
      return flags.orderingStatus.isCateringEnabled;
    }
    return countries[this.$appStore.state.ui.countryProfile.countryCode.toLocaleLowerCase()].isCateringEnabled;
  }

  get headerText(): string {
    if (this.errorCode === OrderErrorCode.MaxBYOLimitExceeded) {
      return `YOU CAN ONLY ADD ONE\n${this.BYOString} TO YOUR BAG`;
    }
    return `DANG, YOUR BAG IS \nGETTING FULL`;
  }

  get buttonText(): string {
    if (this.errorCode === OrderErrorCode.MaxBYOLimitExceeded) {
      return 'OKAY';
    }
    return 'Go to Bag'
  }

  get contentSubtext(): string {
    if (this.errorCode === OrderErrorCode.MaxBYOLimitExceeded) {
      return 'Need to feed a bigger crew?';
    }
    return this.errorMessage ?? '';
  }

  close() {
    this.$services.ui.setModalVisibility('maxEntreeLimitModal', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }

  goToBag() {
    if(!this.$appStore.state.ui.bag.visible) {
      this.$services.bag.setBagVisibility(true);
    }
    this.close();
  }

  onClickCatering() {
    window.open(this.$services.config.getCateringUrl(), '_blank');
    this.close();
  }
}
